export function enterPage(pageName) {
  return {
    type: "ENTER_PAGE",
    pageName,
  };
}
